<template>
    <section class="w-full flex items-center justify-center min-h-screen py-12 md:py-24 lg:py-32" id="pricing">
        <div class="container px-4 md:px-6 mx-auto">
            <div class="flex flex-col items-center justify-center space-y-4 text-center">
                <h2 class="text-3xl font-bold tracking-tight sm:text-5xl">
                    Power Up Your Social Media Game
                </h2>
                <p class="text-xl text-muted-foreground max-w-[600px]">
                    Get yourself some refreshes to update your data to earn XP and rise to the top of the
                    leaderboard!
                </p>
            </div>

            <div class="grid gap-6 mt-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                <div v-for="plan in plans" :key="plan.name"
                    class="relative flex flex-col p-6 bg-white rounded-lg shadow-lg transition-shadow hover:shadow-xl cursor-pointer"
                    :class="{ 'border-2 border-black': plan.popular, 'border border-gray-300': !plan.popular }">
                    <div v-if="plan.popular"
                        class="absolute top-0 right-0 bg-black text-white px-3 py-1 rounded-bl-lg rounded-tr-lg text-sm font-semibold">
                        BEST VALUE
                    </div>
                    <div class="mb-4">
                        <h3 class="text-xl font-bold text-gray-800">{{ plan.name }}</h3>
                        <div class="mt-2 text-3xl font-bold text-gray-800 flex items-end">
                            {{ plan.price }}€
                            <span class="text-xl font-normal text-gray-500">
                                /{{ (plan.price / plan.refreshes).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }) }}€ per refresh
                            </span>
                        </div>
                    </div>
                    <button @click="checkTokenAndRedirect(plan.link)"
                        :class="['w-full py-3 rounded-lg text-sm font-semibold transition-colors', plan.popular ? 'bg-black text-white hover:bg-gray-800' : 'bg-gray-100 text-black hover:bg-gray-200']">
                        Get Refreshes
                    </button>
                </div>
            </div>

            <p class="text-muted-foreground text-sm max-w-lg mx-auto text-center mt-8">
                Each refresh updates your progress on daily missions and achievements, earning you XP that may improve
                your position on the leaderboard.
            </p>
        </div>
    </section>
</template>

<script setup lang="ts">
import router from '@/router';
import { getToken } from '@/utils/tokenUtils';

const plans = [
    {
        name: "25 Refreshes",
        refreshes: 25,
        price: 5,
        features: [
        ],
        link: "https://buy.stripe.com/8wMeVffOk0Ea9eEbIR",
        popular: false
    },
    {
        name: "100 Refreshes",
        refreshes: 100,
        price: 19, // 0,09 € pro Refresh
        features: [

        ],
        link: "https://buy.stripe.com/dR6fZjeKgfz4gH6bIQ",
        popular: false
    },
    {
        name: "200 Refreshes",
        refreshes: 200,
        price: 29, // 0,08 € pro Refresh
        features: [
        ],
        link: "https://buy.stripe.com/4gwbJ30Tq72y3Uk9AH",
        popular: false
    },
    {
        name: "500 Refreshes",
        refreshes: 500,
        price: 59, // 0,06 € pro Refresh
        features: [
        ],
        link: "https://buy.stripe.com/00gbJ30Tq0Ea3Uk9AG",
        popular: false
    },
    {
        name: "1000 Refreshes",
        refreshes: 1000,
        price: 99, // 0,05 € pro Refresh
        features: [
        ],
        link: "https://buy.stripe.com/6oE14peKg72ygH6eUZ",
        popular: true // Best Value
    }
];

const checkTokenAndRedirect = async (link: string) => {
    const token = getToken();
    const response = await fetch(`${import.meta.env.VITE_API_URL}/verify-token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
    });

    if (response.ok) {
        const { valid } = await response.json();

        // Hier kannst du den Kaufstatus überprüfen
        if (valid) {
            window.open(link, '_blank');
        }
    } else {
        router.push('/signup');
    }
};
</script>

<style scoped>
.full-height {
    height: auto;
}
</style>
